import { styled } from '../theme';
import Text from './Text';

const H1 = styled(Text.withComponent('h1'))<{ align?: string }>(({ theme, align = 'left' }) => ({
    ...theme.typography.textStyles.header1,
    textAlign: align,
}));

export default H1;
